import React from "react";
import { Spin } from "antd";
import DateBadge from "./DateBadge.compontent";
import moment from "moment";

const DateFooter = ({ isLoading = false, setRangeDate }) => {
  return (
    <Spin spinning={isLoading}>
      <div className="flex w-full flex-col items-center justify-center ">
        <DateBadge
          onClick={() => {
            setRangeDate([moment().startOf("week"), moment().endOf("week")]);
          }}
        >
          Semaine en cours
        </DateBadge>
        <DateBadge
          onClick={() => {
            setRangeDate([
              moment()
                .subtract(1, "weeks")
                .startOf("week"),
              moment()
                .subtract(1, "weeks")
                .endOf("week")
            ]);
          }}
        >
          Semaine dernière
        </DateBadge>
        <DateBadge
          onClick={() => {
            setRangeDate([moment().startOf("month"), moment().endOf("month")]);
          }}
        >
          Mois en cours
        </DateBadge>

        <DateBadge
          onClick={() => {
            setRangeDate([
              moment()
                .subtract(1, "month")
                .startOf("month"),
              moment()
                .subtract(1, "month")
                .endOf("month")
            ]);
          }}
        >
          Mois dernier
        </DateBadge>
      </div>
    </Spin>
  );
};

export default DateFooter;



// WEBPACK FOOTER //
// src/modules/presence/components/DateFooter.compontent.js